import { Hour } from '../classes/Hour';

export function currWeekDay(): number {
	let currWeekDay = new Date().getDay();
	return !currWeekDay ? 6 : currWeekDay - 1;
}
export function isCurrentTimeInRange(hour: Hour) {
	const currDate = new Date();
	return currDate >= hour.openedAt && currDate <= hour.closedAt;
}
